import { Flex, Link, Text } from '@backstage/ui';
import { EntityInfoCard, useEntity } from '@backstage/plugin-catalog-react';
import { hasPrerequisitesAnnotation, parsePrerequisites } from './prerequisites';
import styles from './TemplatePrerequisites.module.css';

export const TemplatePrerequisites = () => {
  const { entity } = useEntity();

  const prerequisites = parsePrerequisites(entity);

  if (prerequisites.length === 0) {
    // Hide the card entirely if the template doesn't declare any prerequisites.
    if (!hasPrerequisitesAnnotation(entity)) {
      return null;
    }
    return (
      <EntityInfoCard title="Prerequisites">
        <Flex direction="column" className={styles.content}>
          <Text>This template does not have any prerequisites.</Text>
        </Flex>
      </EntityInfoCard>
    );
  }

  const introText =
    prerequisites.length === 1
      ? 'This template has the following prerequisite:'
      : 'This template has the following prerequisites:';

  return (
    <EntityInfoCard title="Prerequisites">
      <Flex direction="column" gap="2" className={styles.content}>
        <Text>{introText}</Text>
        <ul className={styles.list}>
          {prerequisites.map(prerequisite => (
            <li key={prerequisite.key} className={styles.item}>
              {prerequisite.url ? (
                <Link href={prerequisite.url} target="_blank" rel="noreferrer">
                  <strong>{prerequisite.title}</strong>
                </Link>
              ) : (
                <Text>
                  <strong>{prerequisite.title}</strong>
                </Text>
              )}
              <Text>{prerequisite.text}</Text>
            </li>
          ))}
        </ul>
      </Flex>
    </EntityInfoCard>
  );
};
